<template>
  <div v-bind="$attrs">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn fab color="main_pink" :href="game.link" target="_blank"
               class="mx-0 mx-md-2" style="width: 38px; height: 38px;" v-bind="attrs" v-on="on">
          <v-icon light color="#fff">mdi-play</v-icon>
        </v-btn>
      </template>
      <span>{{ $t("generics.play") }}</span>
    </v-tooltip>
  </div>
</template>
<script>
export default {
  name: 'PlayButton',
  props: {
    game: {}
  },
  inheritAttrs: false,
}
</script>

